import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import { ChevronLeft, ChevronRight, Search, Calendar } from 'lucide-react';

interface ProjectItem {
  title: string;
  description: string;
  details: string[];
}

const projectItems: ProjectItem[] = [
  // Page 1
  {
    title: "Headquarters of an International Organization (Old Wan Chai Police Station)",
    description: "R/F, Renovation Works",
    details: [
      "Quantity: 1,200 sqm",
      "Completed Year: 2024",
      "Client:China State Const. Engrg. (HK) Ltd."
    ]
  },
  {
    title: "Star House, Tsim Sha Tsui",
    description: "Re-roofing Work and External Wall Repair Work",
    details: [
      "Quantity: 3,000 sqm",
      "Completed Year: 2024",
      "Client:  Yee Lok Const. & Eng. Ltd."
    ]
  },
  {
    title: "Hong Kong Institute of Vocational Education",
    description: "5F Flat Roof, Blk B",
    details: [
      "Quantity: 500 sqm",
      "Completed Year: 2024",
      "Client: VTC / Wise Profit/ Lanon Development Ltd."
    ]
  },
  {
    title: "Wah Wai Industrial Centre, Fo Tan",
    description: "Roof of Room 5A, 6 &7, 18F, Au Pui Wan Street 38-40",
    details: [
      "Quantity: 300 sqm",
      "Completed Year: 2024",
      "Client: Kin On Professional Construction Ltd."
    ]
  },
  {
    title: "Hong Kong Baptist University",
    description: "Roof of Machine Room, ACC Building",
    details: [
      "Quantity: 270 sqm",
      "Completed Year: 2024",
      "Client: Giant Express Corporation Limited"
    ]
  },
  {
    title: "281 Gloucester Road, Causeway Bay, Hong Kong",
    description: "J9022 Project Blue - Proposed Development",
    details: [
      "Quantity: 38,000 sqm",
      "Completed Year: 2024",
      "Client: Gammon Eng. & Const. Co., Ltd."
    ]
  },
  {
    title: "20 Tsing Yi Road, Tsing Yi Island",
    description: "Development of Aviation and Maritime Education Cetnre",
    details: [
      "Quantity: 22,000 sqm",
      "Completed Year:2024 ",
      "Client: Woon Lee Const. Co., Ltd."
    ]
  },
  {
    title: "To Shek Street, Shantin",
    description: "Development of a Non-profit-making Center for Food Rescue and Food Assistance Purposes",
    details: [
      "Quantity: 12,000 sqm",
      "Completed Year: 2024",
      "Client: Woon Lee Const. Co., Ltd."
    ]
  },
  {
    title: "135 Tai Hang Road, Hong Kong",
    description: "Residential Development at Inland Lot No. 9076",
    details: [
      "Quantity: 19,000 sqm",
      "Completed Year: 2024",
      "Client: China Overseas Building Construction Ltd."
    ]
  },
  {
    title: " Castle Peak Bay, Area 48, Tuen Mun, NT",
    description: "TMTL 518, Castle Peak Road",
    details: [
      "Quantity: 80,000 sqm",
      "Completed Year: 2024",
      "Client: Unistress Building Construction Ltd."
    ]
  },
  // Page 2
  {
    title: "Prince of Wales Hospital",
    description: "Eye Centre, Blocks EF, LM, HK",
    details: [
      "Quantity: 3,800 sqm",
      "Completed Year: 2023",
      "Client: Shui On"
    ]
  },
  {
    title: "Tuen Mun Swimming Pool",
    description: "Pool and facilities waterproofing",
    details: [
      "Quantity: 2,000 sqm",
      "Completed Year: 2022-2024",
      "Client: TCG"
    ]
  },
  {
    title: " Garage No. 11-14",
    description: "Gladdon - Waterproofing to Roof Top",
    details: [
      "Quantity: 80 sqm",
      "Completed Year:2023",
      "Client: Mid-levels Portfolio (Gladdon) Limited"
    ]
  },
  {
    title: "Kwai Fong Youth College",
    description: "Reroofing for 2nd part flat roof on 5F + 2 Nos Roof",
    details: [
      "Quantity: 500 sqm",
      "Completed Year: 2023",
      "Client: VTC / Sing Fat / City Winner"
    ]
  },
  {
    title: "Ma On Shan IVDC",
    description: "Reroofing for 4/F Flat Roof of Assembly and 3 Nos. Houses on G/F ",
    details: [
      "Quantity: 900 sqm",
      "Completed Year: 2023",
      "Client: VTC / Sing Fat / City Winner"
    ]
  },
  {
    title: "On Hing Lane, Shek Mun",
    description: "Columbarium, Garden of Remembrance",
    details: [
      "Quantity: 200 sqm",
      "Completed Year: 2023-2024",
      "Client: China Harbour"
    ]
  },
  {
    title: "Wong Chuk Hang Stationf",
    description: "Residential Development at Site D and Estate Road of Wong Chuk Hang Station",
    details: [
      "Quantity: 77,000 sqm",
      "Completed Year: 2023-2024",
      "Client: China Overseas Building Construction Ltd."
    ]
  },
  {
    title: "Kwai Chung Hospital",
    description: "Redevelopment Kwai Chung Hospital (Phase 2)",
    details: [
      "Quantity: 43,000 sqm",
      "Completed Year: 2023",
      "Client: Shui On JV"
    ]
  },
  {
    title: "Tsai Swimming Pool Complex",
    description: "Redevelopment of Kowloon Tsai Swimming Pool Complex",
    details: [
      "Quantity: 17,000 sqm",
      "Completed Year: 2023",
      "Client: China State"
    ]
  },
  {
    title: " Tseung Kwan O (Po Lam Road)",
    description: "ASD SS F509 - Departmental Quarters for Customs and Excise Department",
    details: [
      "Quantity: 8,000 sqm",
      "Completed Year: 2023",
      "Client: China Harbour"
    ]
  },
  // Page 3
  {
    title: "Hung Shui Kiu Phase 1A, Yuen Long",
    description: "Dedicated Rehousing Estate",
    details: [
      "Quantity: 900 sqm",
      "Completed Year: 2023",
      "Client: Yau Lee Construction Co., Ltd."
    ]
  },
  {
    title: "Kai Tak Cruise Terminal",
    description: "Roof for Tai Mo Shan Weather Radar Station Roof",
    details: [
      "Quantity: 450 sqm",
      "Completed Year: 2022",
      "Client: ASD / Shun Ching"
    ]
  },
  {
    title: "Queensway Plaza, 93 Queensway, Hong Kong",
    description: "Waterproofing for Rooftop",
    details: [
      "Quantity: 800 sqm",
      "Completed Year: 2022",
      "Client: Wheelock / Savills"
    ]
  },
  {
    title: " Eden Gardens, 9-11 Lok Fung Path, Shatin",
    description: "Roof of Flat A & B, Block 1 ",
    details: [
      "Quantity: 560 sqm",
      "Completed Year: 2022",
      "Client: Hong Yip / Trustful"
    ]
  },
  {
    title: "Ma On Shan IVDC",
    description: "4/F Flat Roof",
    details: [
      "Quantity: 1,300 sqm",
      "Completed Year: 2022",
      "Client: VTC / Sing Fat / City Winner"
    ]
  },
  {
    title: "Tuen Mun IVE ",
    description: "Metal Roof of Hall Building",
    details: [
      "Quantity: 700 sqm",
      "Completed Year: 2022",
      "Client: VTC / Sing Fat / City Winner"
    ]
  },
  {
    title: "3 South Bay Close, Hong Kong",
    description: " ",
    details: [
      "Quantity: 1100 sqm",
      "Completed Year: 2022-2023",
      "Client: National / Yee Hop"
    ]
  },
  {
    title: "No. 53, 53A, 55 & 55A Kwun Tong Road",
    description: "Residential & Commercial Building ",
    details: [
      "Quantity: 70,000 sqm",
      "Completed Year: 2022-2023",
      "Client: Unistress Building Construction Ltd."
    ]
  },
   {
    title: "Hung Shui Kiu Quarantine Site",
    description: "",
    details: [
      "Quantity: 6,000 sqm",
      "Completed Year: 2022",
      "Client: China Overseas Building Construction Ltd."
    ]
  },
  {
    title: "Penny's Bay",
    description: "Construction of Community Isolation and Treatment Facilities Ph.5,6A,6B, 6C, 6D & 6E ",
    details: [
      "Quantity: 18,000 sqm",
      "Completed Year: 2022",
      "Client: China Overseas Building Construction Ltd."
    ]
  },
  // Page 4
  {
    title: "Area Adjacent To Kai Tak Cruise Terminal Development",
    description: "Community Isolation Facilities",
    details: [
      "Quantity: 6,000 sqm",
      "Completed Year: 2022",
      "Client: China Overseas Building Construction Ltd."
    ]
  },
  {
    title: "Princess Margaret Hospital",
    description: "Roof of Transformer Room, Lai King Building",
    details: [
      "Quantity: 110 sqm",
      "Completed Year: 2022",
      "Client: Hospial Authority/P&T/Tysan"
    ]
  },
  {
    title: "Wong Chuk Hang Station, Aberdeen Inland Lot No. 467 - Site D - Depot Roof",
    description: "Proposed Residential Development ",
    details: [
      "Quantity: 1,600 sqm",
      "Completed Year: 2022",
      "Client: China Overseas Building Construction Ltd."
    ]
  },
  {
    title: "Kwai Fong Youth College ",
    description: "partial flat roof on 5F & Roof of G/F Plant Room",
    details: [
      "Quantity: 250 sqm",
      "Completed Year: 2022",
      "Client: VTC / Sing Fat / City Winner"
    ]
  },
  {
    title: "TMTL 544, Tuen Mun",
    description: "Proposed Logistics Development",
    details: [
      "Quantity: 47,000 sqm",
      "Completed Year: 2022",
      "Client: China Overseas Building Construction Ltd."
    ]
  },
  {
    title: "New Asia Compus for CUHK",
    description: "300 Place Student Hostel",
    details: [
      "Quantity: 47,000 sqm",
      "Completed Year: 2022",
      "Client:Build King Const. Ltd"
    ]
  },
  {
    title: "Redevelopment of Kwong Wah Hospital (K.I.L. 10748)",
    description: " ",
    details: [
      "Quantity: 70,000 sqm",
      "Completed Year: 2021-2022",
      "Client: China Overseas Building Construction Ltd."
    ]
  },
  {
    title: "Residential Development at New Kowloon Inland Lot No. 6575, Kai Tak",
    description: "",
    details: [
      "Quantity: 85,000 sqm",
      "Completed Year: 2021-2022",
      "Client: China Overseas Building Construction Ltd."
    ]
  },
  {
    title: "Nos. 30-50 Gillies Avenue South, 75-81 Baker Street, 23-41 Whampoa Street and 12A-22A Bulkeley Street",
    description: " ",
    details: [
      "Quantity: 1,500 sqm",
      "Completed Year: 2020",
      "Client: Heng Shung Construction Co., Ltd."
    ]
  },
  {
    title: "Construction of Subsidised Sales Flat Development at Diamond Hill Comprehensive Development Area",
    description: "",
    details: [
      "Quantity: 1,800 sqm",
      "Completed Year: 2020",
      "Client: Yau Lee Construction Co., Ltd."
    ]
  },
  // Page 5
  {
    title: "Asia World Expo Temporary Hospital",
    description: "Medical facility waterproofing",
    details: [
      "Quantity: 20,000 sqm",
      "Completed Year: 2020",
      "Client: Treasure Construction Eng. Ltd. (China State)"
    ]
  },
  {
    title: "Residential Development at Site A & Site B and Estate Road of Wong Chuk Hang Station",
    description: " ",
    details: [
      "Quantity: 135,000 sqm",
      "Completed Year: 2020",
      "Client: China Overseas Building Construction Ltd."
    ]
  },
  {
    title: "Morrision Hill VTC",
    description: "Main Building Main Roof (Upper Roof fm 6/F Flat Roof)",
    details: [
      "Quantity: 950 sqm",
      "Completed Year: 2020-2021",
      "Client: VTC / CR / Wise Profit"
    ]
  },
  {
    title: "Alice Ho Miu Ling Nethersole Hospital",
    description: "Re-roofing, 4/F Flat Roof",
    details: [
      "Quantity: 340 sqm",
      "Completed Year: 2020-2021",
      "Client: Hospital Authority / Square / Wise Profit"
    ]
  },
  {
    title: "Tuen Mun IVE",
    description: "Metal Roof of Hall Building",
    details: [
      "Quantity: 900 sqm",
      "Completed Year: 2020-2021",
      "Client: VTC / Sing Fat / City Winner"
    ]
  },
  {
    title: "Shatin Hospital",
    description: "Roof & Upper Roof of JCCPA Block A",
    details: [
      "Quantity: 550 sqm",
      "Completed Year: 2020",
      "Client: Hospital Authority / Square / Wise Profit"
    ]
  },
  {
    title: " Prince of Wales Hospital",
    description: "Re-roofing, Staff Quarters, Block B",
    details: [
      "Quantity: 1,600 sqm",
      "Completed Year: 2020",
      "Client:  Hospital Authority / Square / Wise Profit"
    ]
  },
  {
    title:  "Ma On Shan IVDC",
    description: "Partial 4/F Flat Roof and 3/F Flat Roof",
    details: [
      "Quantity: 400 sqm",
      "Completed Year: 2020",
      "Client: VTC / Sing Fat / City Winner"
    ]
  },
  {
    title: "Wales Hospital",
    description: "Roof of Lui Che Woo Clinical Sciences Building",
    details: [
      "Quantity: 250 sqm",
      "Completed Year: 2020",
      "Client: Hospital Authority / Square / Wise Profit"
    ]
  },
  {
    title: "Disneyland",
    description: "Disneyland Bldg 201 Ticket Booth Roof ",
    details: [
      "Quantity: 300 sqm",
      "Completed Year: 2020",
      "Client: Disneyland / Taste Interiors"
    ]
  },
  // Page 6
  {
    title: "Morrison Hill VTC",
    description: "3F Flat Roof",
    details: [
      "Quantity: 100 sqm",
      "Completed Year: 2020",
      "Client: VTC / Square / Wise Profit"
    ]
  },
  {
    title: "Tin Shui Wai Youth College",
    description: "Roof (2nd Phase)",
    details: [
      "Quantity: 450 sqm",
      "Completed Year: 2020",
      "Client: VTC / Sing Fat / City Winner"
    ]
  },
  {
    title: "Lei Yue Mun Park and Holiday Village",
    description: "Provision of Temporary Quarantine Facilities",
    details: [
      "Quantity: 3000 sqm",
      "Completed Year: 2020",
      "Client: China State Const. Engrg. (HK) Ltd."
    ]
  },
  {
    title: "Ap Lei Chau Market",
    description: "Corrugated Steel Roof",
    details: [
      "Quantity: 600 sqm",
      "Completed Year: 2020",
      "Client: Uni-China Business Management"
    ]
  },
  {
    title: "Tuen Mun Shine Skill Centre",
    description: "Roof (2nd Phase)",
    details: [
      "Quantity: 500 sqm",
      "Completed Year: 2020",
      "Client: VTC / Sing Fat / City Winner"
    ]
  },
  {
    title: "Education University of Hong Kong",
    description: "Block B2 & B3 Roof",
    details: [
      "Quantity: 1000 sqm",
      "Completed Year: 2019",
      "Client: Education University of Hong Kong"
    ]
  },
  {
    title: "North West Kowloon Reclamation Site 6 and Fat Tseung Street West",
    description: "Construction of Public Housing Developments",
    details: [
      "Quantity: 2500 sqm",
      "Completed Year: 2020",
      "Client: Yau Lee Construction Co., Ltd."
    ]
  },
  {
    title: "Hong Kong Palace Museum",
    description: "External Basement Tanking for the West Kowloon Cultural District",
    details: [
      "Quantity: 7000 sqm",
      "Completed Year: 2019",
      "Client: China State Const. Engrg. (HK) Ltd."
    ]
  },
  {
    title: "Hong Kong Palace Museum",
    description: "Foundation Works for The West Kowloon Cultural District",
    details: [
      "Quantity: 4000 sqm",
      "Completed Year: 2019",
      "Client: Gammon"
    ]
  },
  {
    title: "TMTL 500, Kwun Chui Road, Tuen Mun",
    description: "Proposed Residential Development",
    details: [
      "Quantity: 94,000 sqm",
      "Completed Year: 2019-20",
      "Client: China Overseas Building Construction Ltd."
    ]
  },
  {
    title: "STTL 601, Yiu Sha Road, Whitehead, Ma On Shan",
    description: "Residential Development",
    details: [
      "Quantity: 67,000 sqm",
      "Completed Year: 2019-20",
      "Client: China Overseas Building Construction Ltd."
    ]
  },
  {
    title: "Disneyland Buildings",
    description: "Re-roofing of Buildings 204, 211, 304, 403 & 506",
    details: [
      "Quantity: 3500 sqm",
      "Completed Year: 2019",
      "Client: Disneyland"
    ]
  },
  {
    title: "Windsor House",
    description: "Re-roofing for A&A",
    details: [
      "Quantity: 6000 sqm",
      "Completed Year: 2019",
      "Client: Martin Construction Co. Ltd."
    ]
  },
  {
    title: "CUHK Medical Centre",
    description: "Medical Centre at The Chinese University of Hong Kong",
    details: [
      "Quantity: 80000 sqm",
      "Completed Year: 2019",
      "Client: China State Const. Engrg. (HK) Ltd."
    ]
  },
  {
    title: "Lyric Theatre Complex",
    description: "L1 Contract for Theatre Complex and Extended Basement Project for The West Kowloon Cultural District",
    details: [
      "Quantity: 66000 sqm",
      "Completed Year: 2018-21",
      "Client: Gammon"
    ]
  },
  {
    title: "S.T.T.L. No. 605, Lok Wo Sha Lane, Sha Tin",
    description: "Proposed Residential Development",
    details: [
      "Quantity: 25,000 sqm",
      "Completed Year: 2018",
      "Client: China Overseas Building Construction Ltd."
    ]
  },
  {
    title: "The University of Chicago Centre",
    description: "Centre in Hong Kong at Victoria Road",
    details: [
      "Quantity: 1,000 sqm",
      "Completed Year: 2018",
      "Client: Paul Y"
    ]
  },
  {
    title: "NKIL6534, Fuk Wing Street",
    description: "Camp Street & Fuk Wa Street, Shamshuipo",
    details: [
      "Quantity: 41,000 sqm",
      "Completed Year: 2018",
      "Client: Build King Const. Ltd"
    ]
  },
  {
    title: "Disneyland Buildings",
    description: "Re-roofing of Buildings 204, 211, 304, 403 & 506",
    details: [
      "Quantity: 6000 sqm",
      "Completed Year: 2018",
      "Client: Disneyland"
    ]
  },
  {
    title: "Jockey Club Vehicle Centre",
    description: "Vehicle Centre at Tsing Yi VTC",
    details: [
      "Quantity: 400 sqm",
      "Completed Year: 2018",
      "Client: VTC / Square"
    ]
  },
  {
    title: "Kwai Fong Youth College",
    description: "",
    details: [
      "Quantity: 1000 sqm",
      "Completed Year: 2018",
      "Client: VTC / Square"
    ]
  },
  {
    title: "Ocean Park Tai Shue Wan Water World",
    description: "",
    details: [
      "Quantity: 85,000 sqm",
      "Completed Year: 2018-20",
      "Client: Gammon"
    ]
  },
  {
    title: "Fresh Water Tank at Tower 3 Water Pump Room of Sorrento",
    description: "",
    details: [
      "Quantity: 20 sqm",
      "Completed Year: 2018",
      "Client: MTR - Sorrento Management Office"
    ]
  },
  {
    title: "Flat Roof at Kowloon Bay IVE",
    description: "",
    details: [
      "Quantity: 900 sqm",
      "Completed Year: 2018",
      "Client: VTC / Unistress"
    ]
  },
  {
    title: "6 Moorsom Road Jardine's Lockout",
    description: "",
    details: [
      "Quantity: 700 sqm",
      "Completed Year: 2018",
      "Client: Art Const"
    ]
  },
  {
    title: "Tuen Mun VTC Carpark, Main Building and Annex Building",
    description: "",
    details: [
      "Quantity: 2000 sqm",
      "Completed Year: 2018",
      "Client: VTC / Square"
    ]
  },
  {
    title: "Disneyland - Gutter in City Hall and Train Station",
    description: "",
    details: [
      "Quantity: 200 sqm",
      "Completed Year: 2017-2018",
      "Client: Disneyland (Silver Star)"
    ]
  },
  {
    title: "Shop, Wah Wai Industrial Centre, Fo Tan",
    description: "",
    details: [
      "Quantity: 600 sqm",
      "Completed Year: 2020",
      "Client: BCI Engineering"
    ]
  },
  {
    title: "Subsidized Sale Flat Project at Shat Tin Area 36C",
    description: "",
    details: [
      "Quantity: 99,000 sqm",
      "Completed Year: 2018",
      "Client: Chun Wo"
    ]
  },
  {
    title: "Proposed Residential Development at No. 68-86 Wan Fung Street on N.K.I.L. 5035, Wong Tai Sin",
    description: "",
    details: [
      "Quantity: 15,000 sqm",
      "Completed Year: 2018",
      "Client: CR Construction Company Limited"
    ]
  },
  {
    title: "Refuge Floors above Units in 32/F of Block 1, Coastal Skyline",
    description: "",
    details: [
      "Quantity: 150 sqm",
      "Completed Year: 2017",
      "Client: MTR- Coastal skyline Management Office"
    ]
  },
  {
    title: "Re-roofing at 15 Magazine Gap Road",
    description: "",
    details: [
      "Quantity: 500 sqm",
      "Completed Year: 2018",
      "Client: Wadabuild Const. Co., Ltd."
    ]
  },
  {
    title: "VTC Maritime Services Training Institute, Tai Lam Chung",
    description: "",
    details: [
      "Quantity: 3000 sqm",
      "Completed Year: 2018",
      "Client: VTC / Square"
    ]
  },
  {
    title: "Commercial development of 575-575A, Nathan Road, Kowloon",
    description: "",
    details: [
      "Quantity: 2,500 sqm",
      "Completed Year: 2017",
      "Client: Win Win Way"
    ]
  },
  {
    title: "1 Hennessy Road",
    description: "",
    details: [
      "Quantity: 27,000 sqm",
      "Completed Year: 2018",
      "Client: CR Construction Company"
    ]
  },
  {
    title: "Commercial Complex at Lot. No. 678 in D.D Peng Chau",
    description: "",
    details: [
      "Quantity: 20,000 sqm",
      "Completed Year: 2017",
      "Client: Win Win Way"
    ]
  },
  {
    title: "Clearwater Bay Golf Country Club - Tennis Court",
    description: "",
    details: [
      "Quantity: 760 sqm",
      "Completed Year: 2017",
      "Client: The Clearwater Bay Golf & Country Club"
    ]
  },
  {
    title: "Public Rental Housing Development at Fanling Area 49",
    description: "",
    details: [
      "Completed Year: 2017",
      "Client: Yau Lee"
    ]
  },
  {
    title: "Rural Building Lot No. 1165, Repulse Bay",
    description: "",
    details: [
      "Quantity: 12,000 sqm",
      "Completed Year: 2017",
      "Client: Wang Yip Construction Company Ltd."
    ]
  },
  {
    title: "Tung Chung Area 56 Carpark",
    description: "",
    details: [
      "Quantity: 1,800 sqm",
      "Completed Year: 2017",
      "Client: Hsin Chong (HKHA)"
    ]
  },
  {
    title: "Lift pit in Kennedy Town Jockey Club Clinic",
    description: "",
    details: [
      "Completed Year: 2017",
      "Client: Square"
    ]
  },
  {
    title: "Residential Development in Beacon Hill, Kowloon",
    description: "",
    details: [
      "Quantity: 28,000 sqm",
      "Completed Year: 2017",
      "Client: CR Construction Company"
    ]
  },
  {
    title: "Re-roofing of Disneyland 404, 409, 413",
    description: "",
    details: [
      "Quantity: 7000 sqm",
      "Completed Year: 2017",
      "Client: Disneyland"
    ]
  },
  {
    title: "Roof of Small Boat Division (SBDIV) - Stonecutters Island",
    description: "",
    details: [
      "Quantity: 1300 sqm",
      "Completed Year: 2017",
      "Client: Nam Cheong"
    ]
  },
  {
    title: "Malvern College Hong Kong Campus at Area 4, Fo Chun Road, Tai Po",
    description: "",
    details: [
      "Quantity: 2,000 sqm",
      "Completed Year: 2017",
      "Client: Build King"
    ]
  },
  {
    title: "Roof of Tung Tau Correctional Institution Junior Staff married Quarters Block 2",
    description: "",
    details: [
      "Quantity: 500 sqm",
      "Completed Year: 2016",
      "Client: ASD / Shui On"
    ]
  },
  {
    title: "Roof of East Kowloon Polyclinic",
    description: "",
    details: [
      "Quantity: 1200 sqm",
      "Completed Year: 2017",
      
      "Client: Hospital Authority / Unitress"
    ]
  },
  {
    title: "Roof of Buddhist Sin Tak College",
    description: "",
    details: [
      "Quantity: 800 sqm",
      "Completed Year: 2017",
      "Client: Shui On"
    ]
  },
  {
    title: "Sport Court of Youth College - Yeo Chei Man",
    description: "",
    details: [
      "Quantity: 400 sqm",
      "Completed Year: 2017",
      "Client: Shui On"
    ]
  },
  {
    title: "45 Tai Tam Road",
    description: "",
    details: [
      "Quantity: 5,000 sqm",
      "Completed Year: 2017",
      "Client: Fuji"
    ]
  },
  {
    title: "Proposed Hotel Development in 148-150 Austin Road",
    description: "",
    details: [
      "Quantity: 9,500 sqm",
      "Completed Year: 2017",
      "Client: CR Construction Company"
    ]
  },
  {
    title: "Public Rental Housing Redevelopment at Pak Tin Ph 7 & 8",
    description: "",
    details: [
      "Quantity: 50,000 sqm",
      "Completed Year: 2017-21",
      "Client: Chun Wo"
    ]
  },
  {
    title: "Roof of Tsuen Wan Public Ho Chuen Yiu Memorial College",
    description: "",
    details: [
      "Quantity: 1000 sqm",
      "Completed Year: 2016",
      "Client: Shui On"
    ]
  },
  {
    title: "Roof of Kwun Tong Shine Skill Center (Center)",
    description: "",
    details: [
      "Quantity: 600 sqm",
      "Completed Year: 2016",
      "Client: VTC / Unistress"
    ]
  },
  {
    title: "Roof of S.K.H. ST.Clement Primary School",
    description: "",
    details: [
      "Quantity: 700 sqm",
      "Completed Year: 2016",
      "Client: Shui On"
    ]
  },
  {
    title: "Roof of HKSYC&IA Chan Nam Chong Memorial School",
    description: "",
    details: [
      "Quantity: 1000 sqm",
      "Completed Year: 2017",
      "Client: Shui On"
    ]
  },
  {
    title: "Re-roofing of TWGH's S C Gaw Memorial College",
    description: "",
    details: [
      "Quantity: 800 sqm",
      "Completed Year: 2017",
      "Client: Shui On"
    ]
  },
  {
    title: "E.J. at Ping Shek Estate Podium",
    description: "",
    details: [
      "Quantity: 70m",
      "Completed Year: 2016-2017",
      "Client: HKHA / Creative Concept"
    ]
  },
  {
    title: "VTC Whole Person Development Education Centre at Tai Lam",
    description: "",
    details: [
      "Quantity: 700 sqm",
      "Completed Year: 2016",
      "Client: VTC / Square"
    ]
  },
  {
    title: "Re-roofing Works for Lower Block (Block 3) above Flat 09-15 of Oi Fai House in Yau Oi Estate",
    description: "",
    details: [
      "Quantity: 400 sqm",
      "Completed Year: 2016-17",
      "Client: HKHA"
    ]
  },
  {
    title: "Roof of Hong Kong Design Institute",
    description: "",
    details: [
      "Quantity: 800 sqm",
      "Completed Year: 2016-17",
      "Client: VTC / Unistress"
    ]
  },
  {
    title: "Phase 3, Re-roofing of The Clearwater Bay Golf & Country Club",
    description: "",
    details: [
      "Quantity: 3000 sqm",
      "Completed Year: 2016-17",
      "Client: The Clearwater Bay Golf & Country Club"
    ]
  },
  {
    title: "Disneyland H3 First Class Hotel",
    description: "",
    details: [
      "Quantity: 33,200 sqm",
      "Completed Year: 2017",
      "Client: Yearfull"
    ]
  },
  {
    title: "Commercial Development at Lam Lee St, Kowloon Bay",
    description: "",
    details: [
      "Quantity: 20,000 sqm",
      "Completed Year: 2016-17",
      "Client: Hsin Chong"
    ]
  },
  {
    title: "Scout Association of Hong Kong at 34 Oi Kwan Road, Wan Chai",
    description: "",
    details: [
      "Quantity: 2,000 sqm",
      "Completed Year: 2016",
      "Client: Build King"
    ]
  },
  {
    title: "The Hong Kong Ocean Park Marriott Hotel at Ocean Park, HK",
    description: "",
    details: [
      "Quantity: 8,000 sqm",
      "Completed Year: 2017",
      "Client: Hsin Chong"
    ]
  },
  {
    title: "HK-Zhuhai-Macao Bridge, HK Boundary Crossing Facilities",
    description: "",
    details: [
      "Quantity: 50,000 sqm",
      "Completed Year: 2016",
      "Client: China Harbour"
    ]
  },
  {
    title: "Centre of Excellence in Paediatrics",
    description: "",
    details: [
      "Quantity: 100,000 sqm",
      "Completed Year: 2016",
      "Client: China State - Shui On Joint Venture"
    ]
  },
  {
    title: "Roof for S.K.H. Yan Laap Primary School",
    description: "",
    details: [
      "Quantity: 400 sqm",
      "Completed Year: 2016",
      "Client: Shui On"
    ]
  },
  {
    title: "Ho Man Tin, Sheung Shing Street, WP",
    description: "",
    details: [
      "Quantity: 100,000 sqm",
      "Completed Year: 2015",
      "Client: Hsin Chong"
    ]
  },
  {
    title: "Fat Kwong Street, Homantin",
    description: "",
    details: [
      "Quantity: 150 sqm",
      "Completed Year: 2016",
      "Client: Yearfull"
    ]
  },
  {
    title: "Patrick Mansion Building, Hong Kong University",
    description: "",
    details: [
      "Quantity: 400 sqm",
      "Completed Year: 2016",
      "Client: Macnotta"
    ]
  },
  {
    title: "Balcony on 13/F Platform in Wings Building, 110-116 Queen's Road, Central",
    description: "",
    details: [
      "Quantity: 100 sqm",
      "Completed Year: 2016",
      "Client: Hong Yip"
    ]
  },
  {
    title: "Maintenance Shed, Country Club, The Clearwater Bay Golf & Country Club",
    description: "",
    details: [
      "Quantity: 1000 sqm",
      "Completed Year: 2016",
      "Client: The Clearwater Bay Golf & Country Club"
    ]
  },
  {
    title: "Heritage for So Uk Estate",
    description: "",
    details: [
      "Quantity: 1,000 sqm",
      "Completed Year: 2016",
      "Client: Shui On"
    ]
  },
  {
    title: "Chai Wan IVE - Shape Building",
    description: "",
    details: [
      "Quantity: 400 sqm",
      "Completed Year: 2016",
      "Client: VTC / Unistress"
    ]
  },
  {
    title: "Chai Wan IVE – Administration Block",
    description: "",
    details: [
      "Quantity: 1000 sqm",
      "Completed Year: 2016",
      "Client: VTC / Unistress"
    ]
  },
  {
    title: "Cell Block D of Stanley Prisons",
    description: "",
    details: [
      "Quantity: 1200 sqm",
      "Completed Year: 2016",
      "Client: ASD / Shui On"
    ]
  },
  {
    title: "Cape Collinson Crematorium",
    description: "",
    details: [
      "Quantity: 150 sqm",
      "Completed Year: 2016",
      "Client: Cheung Hing"
    ]
  },
  {
    title: "Re-roofing of Yiu Kwai House in Yiu Tung Estate & Annex Block of Tung Wong House in Tai Hang Tung Estate",
    description: "",
    details: [
      "Quantity: 1700 sqm",
      "Completed Year: 2015-2016",
      "Client: HKHA"
    ]
  },
  {
    title: "Re-roofing of Chui Yuen House, Chuk Yuen Estate",
    description: "",
    details: [
      "Quantity: 3200 sqm",
      "Completed Year: 2015-2016",
      "Client: HKHA"
    ]
  },
  {
    title: "Re-roofing of Wing Tong House at Yau Tong Estate",
    description: "",
    details: [
      "Quantity: 1500 sqm",
      "Completed Year: 2015-16",
      "Client: HKHA"
    ]
  },
  {
    title: "Re-roofing of Tat Sin House, Upper Wong Tai Sin Estate",
    description: "",
    details: [
      "Quantity: 1500 sqm",
      "Completed Year: 2015-16",
      "Client: HKHA"
    ]
  },
  {
    title: "Re-roofing Works for Disneyland Hotel",
    description: "",
    details: [
      "Quantity: 10000 sqm",
      "Completed Year: 2015-16",
      "Client: HKHA"
    ]
  },
  {
    title: "Noval Building Roof",
    description: "",
    details: [
      "Quantity: 700 sqm",
      "Completed Year: 2016",
      "Client: Jones Lang LaSalle"
    ]
  },
  {
    title: "Public Rental Housing Development at Ex-Yuen Long Estate",
    description: "",
    details: [
      "Quantity: 15000 sqm",
      "Completed Year: 2015",
      "Client: Shui On"
    ]
  },
  {
    title: "Foundation Works for Hotel Development at Lot 1950, Wai Man Road, Sai Kung",
    description: "",
    details: [
      "Quantity: 15000 sqm",
      "Completed Year: 2015",
      "Client: New Concept"
    ]
  }
];

const MoreProjects: React.FC = () => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [filteredAndPaginatedProjects, setFilteredAndPaginatedProjects] = useState<ProjectItem[]>([]);
  const [totalFilteredPages, setTotalFilteredPages] = useState(0);
  const navigate = useNavigate();

  const ITEMS_PER_PAGE = 10;
  const YEARS = Array.from({ length: 10 }, (_, i) => 2024 - i);

  // Filter and paginate projects whenever search criteria or page changes
  useEffect(() => {
    const filterAndPaginate = () => {
      let filteredItems = projectItems;

      // Apply search term filter
      if (searchTerm) {
        filteredItems = filteredItems.filter(item =>
          item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.details.some(detail => detail.toLowerCase().includes(searchTerm.toLowerCase()))
        );
      }

      // Apply year filter
      if (selectedYear) {
        filteredItems = filteredItems.filter(item =>
          item.details.some(detail => 
            detail.includes(`Completed Year: ${selectedYear}`) ||
            detail.includes(`${selectedYear}-`)
          )
        );
      }

      // Calculate total pages
      const totalPages = Math.ceil(filteredItems.length / ITEMS_PER_PAGE);
      setTotalFilteredPages(totalPages);

      // Adjust current page if it's out of bounds
      let adjustedCurrentPage = currentPage;
      if (totalPages > 0 && currentPage >= totalPages) {
        adjustedCurrentPage = totalPages - 1;
        setCurrentPage(adjustedCurrentPage);
      } else if (totalPages === 0) {
        adjustedCurrentPage = 0;
        setCurrentPage(0);
      }

      // Get items for current page
      const start = adjustedCurrentPage * ITEMS_PER_PAGE;
      const paginatedItems = filteredItems.slice(start, start + ITEMS_PER_PAGE);
      
      setFilteredAndPaginatedProjects(paginatedItems);
    };

    filterAndPaginate();
  }, [searchTerm, selectedYear, currentPage]);

  const toggleItem = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const scrollToTop = () => {
    const header = document.querySelector('.container');
    if (header) {
      header.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const nextPage = () => {
    if (currentPage < totalFilteredPages - 1) {
      setExpandedIndex(null);
      setCurrentPage(prev => prev + 1);
      scrollToTop();
    }
  };

  const prevPage = () => {
    if (currentPage > 0) {
      setExpandedIndex(null);
      setCurrentPage(prev => prev - 1);
      scrollToTop();
    }
  };

  const handleSearch = () => {
    setCurrentPage(0);
    setExpandedIndex(null);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="container mx-auto px-4 pt-32 pb-24">
        <div className="max-w-5xl mx-auto">
          <div className="mb-12 flex flex-col md:flex-row items-center justify-between">
            <div className="text-center md:text-left mb-6 md:mb-0">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">More Projects</h2>
              <div className="w-24 h-1 bg-[#d40715] mb-6 md:mb-0 mx-auto md:mx-0"></div>
            </div>
            <button 
              onClick={() => window.history.back()}
              className="px-6 py-2 border-2 border-[#d40715] text-[#d40715] rounded-md hover:bg-[#d40715] hover:text-white transition-all duration-300"
            >
              Back to Projects
            </button>
          </div>

          <p className="text-gray-600 text-lg leading-relaxed text-center mb-8">
            Explore our extensive portfolio of successful waterproofing projects across various sectors in Hong Kong.
          </p>

          <div className="bg-white p-6 rounded-lg shadow-md mb-8">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search projects..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#d40715] focus:border-transparent"
                  />
                  <Search className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <div className="relative">
                  <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    className="w-full px-4 py-2 pr-10 appearance-none border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#d40715] focus:border-transparent"
                  >
                    <option value="">All Years</option>
                    {YEARS.map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                  <Calendar className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={20} />
                </div>
                
                <button
                  onClick={handleSearch}
                  className="px-4 py-2 bg-[#d40715] text-white rounded-md hover:bg-[#b00612] transition-colors duration-300 flex items-center justify-center gap-2 min-w-[100px]"
                >
                  <Search size={18} />
                  <span>Search</span>
                </button>
              </div>
            </div>
          </div>

          <div className="space-y-6 w-full">
            {filteredAndPaginatedProjects.map((item, index) => (
              <div
                key={index}
                className={`bg-white rounded-lg shadow-md overflow-hidden transition-all duration-500 transform ${
                  expandedIndex === index ? 'scale-[1.02] shadow-lg' : 'hover:shadow-lg'
                }`}
              >
                <button
                  onClick={() => toggleItem(index)}
                  className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-300"
                >
                  <div>
                    <h3 className={`text-xl font-semibold transition-colors duration-300 ${
                      expandedIndex === index ? 'text-[#d40715]' : 'text-gray-800'
                    }`}>
                      {item.title}
                    </h3>
                    <p className="text-gray-600 mt-1">{item.description}</p>
                  </div>
                  <ChevronRight 
                    className={`text-[#d40715] flex-shrink-0 transition-all duration-300 ${
                      expandedIndex === index ? 'rotate-90' : ''
                    }`}
                    size={24}
                  />
                </button>
                <div
                  className={`transform transition-all duration-500 ease-in-out origin-top ${
                    expandedIndex === index 
                      ? 'opacity-100 max-h-[500px]' 
                      : 'opacity-0 max-h-0'
                  }`}
                >
                  <div className={`px-6 py-4 border-t border-gray-100 transition-all duration-500 transform ${
                    expandedIndex === index 
                      ? 'translate-y-0 opacity-100' 
                      : 'translate-y-4 opacity-0'
                  }`}>
                    <ul className="space-y-2">
                      {item.details?.map((detail, detailIndex) => (
                        <li 
                          key={detailIndex}
                          className={`transform transition-all duration-300 delay-${detailIndex * 100} ${
                            expandedIndex === index 
                              ? 'translate-x-0 opacity-100 text-gray-600' 
                              : 'translate-x-4 opacity-0'
                          }`}
                        >
                          {detail.replace(/^Completed Year:/, 'Project Period:')}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Show message when no results found */}
          {filteredAndPaginatedProjects.length === 0 && (searchTerm || selectedYear) && (
            <div className="text-center py-12">
              <p className="text-gray-500 text-lg">No projects found matching your search criteria.</p>
            </div>
          )}

          <div className="mt-8 flex items-center justify-center gap-8">
            <button
              onClick={prevPage}
              disabled={currentPage === 0 || totalFilteredPages === 0}
              className="p-2 rounded-full bg-white shadow-md hover:shadow-lg transition-all duration-300 hover:bg-gray-50 text-[#d40715] disabled:opacity-50 disabled:cursor-not-allowed"
              aria-label="Previous page"
            >
              <ChevronLeft size={24} />
            </button>
            
            <span className="text-lg font-medium text-gray-700">
              {totalFilteredPages === 0 ? '0' : `${currentPage + 1} / ${totalFilteredPages}`}
            </span>
            
            <button
              onClick={nextPage}
              disabled={currentPage >= totalFilteredPages - 1 || totalFilteredPages === 0}
              className="p-2 rounded-full bg-white shadow-md hover:shadow-lg transition-all duration-300 hover:bg-gray-50 text-[#d40715] disabled:opacity-50 disabled:cursor-not-allowed"
              aria-label="Next page"
            >
              <ChevronRight size={24} />
            </button>
          </div>
        </div>
      </div>
      <ScrollToTop />
      <Footer />
    </div>
  );
};

export default MoreProjects;